import React, { ReactElement, useState, useRef, useEffect } from 'react';
import { Button, Col, Modal, Row, Form } from 'react-bootstrap';
import { toISODate } from '../../../Utils/dateUtils';
import ChampFormulaire from '../../Common/ChampFormulaire';
import CheckboxFormulaire from '../../Common/CheckboxFormulaire';
import ClientContact from '../../../../../common/src/entities/client-contact.entity';
import { useFormikContext } from 'formik';
import { LABEL_COL_MODAL, SUGGESTIONS_POSTE } from '../constantes';

const TITRE_MODAL = 'Modifier' as const;
const TITRE_CHAMP_POSTE = 'Poste' as const;
const TITRE_CHAMP_DEBUT = 'Date de début' as const;
const TITRE_CHAMP_FIN = 'Date de fin' as const;

interface PropsModal {
    afficher: boolean;
    setAfficher: () => void;
    index: number;
}

export function ModalClientContact(props: PropsModal): ReactElement {
    const { values, setFieldValue } = useFormikContext<ClientContact>();

    let isChecked = true;
    if (
        values['contacts'] !== undefined &&
        values['contacts'].length !== 0 &&
        values['contacts'][props.index] !== undefined
    ) {
        isChecked = values['contacts'][props.index].actif === true;
    }

    function handleCheckboxChange(newValue: boolean) {
        isChecked = newValue;
        if (newValue === false) {
            setFieldValue(`contacts[${props.index}].fin`, new Date().toISOString().split('T')[0]);
        } else {
            setFieldValue(`contacts[${props.index}].fin`, '');
        }
    }

    return (
        <Modal show={props.afficher} onHide={props.setAfficher}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <small className="text-muted">{TITRE_MODAL}</small>&nbsp;
                    {values && values['contacts'] && values['contacts'][props.index]
                        ? values['contacts'][props.index]['contact']['name']
                        : 'No Name Available'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <CheckboxFormulaire
                            id={`contacts[${props.index}].actif`}
                            titre="Actif"
                            isChecked={isChecked}
                            notifyChange={handleCheckboxChange}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ChampFormulaire
                            id={`contacts[${props.index}].poste`}
                            titre={TITRE_CHAMP_POSTE}
                            isCreatable
                            suggestions={SUGGESTIONS_POSTE}
                            estPetit
                            labelCol={LABEL_COL_MODAL}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ChampFormulaire
                            type="date"
                            id={`contacts[${props.index}].debut`}
                            titre={TITRE_CHAMP_DEBUT}
                            parser={(date) => toISODate(date as string)}
                            labelCol={LABEL_COL_MODAL}
                            estPetit
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ChampFormulaire
                            type="date"
                            id={`contacts[${props.index}].fin`}
                            titre={TITRE_CHAMP_FIN}
                            parser={(date) => toISODate(date as string)}
                            labelCol={LABEL_COL_MODAL}
                            estPetit
                        />
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}
